import {AxiosInstance} from 'axios';
import {action, makeObservable, observable} from 'mobx';

export class SidebarStore {
  isOpen: boolean = true;

  constructor(protected readonly api: AxiosInstance) {
    makeObservable(this, {
      isOpen: observable,
      setIsOpen: action,
    });
  }

  setIsOpen(isOpen = false) {
    this.isOpen = isOpen;
  }
}
